import { NgModule } from '@angular/core';
import { CipoAddressComponent } from '@shared/components/fields/cipo-address/cipo-address.component';

import { CipoAttachmentComponent } from '@shared/components/fields/cipo-attachment/cipo-attachment.component';
import { CipoCheckboxComponent } from '@shared/components/fields/cipo-checkbox/cipo-checkbox.component';
import { CipoDateTimeComponent } from '@shared/components/fields/cipo-date-time/cipo-date-time.component';
import { CipoListboxComponent } from '@shared/components/fields/cipo-listbox/cipo-listbox.component';
import { CipoNumberComponent } from '@shared/components/fields/cipo-number/cipo-number.component';
import { CipoRadioGroupComponent } from '@shared/components/fields/cipo-radio-group/cipo-radio-group.component';
import { CipoSelectComponent } from '@shared/components/fields/cipo-select/cipo-select.component';
import { CipoTextComponent } from '@shared/components/fields/cipo-text/cipo-text.component';

@NgModule({
  imports: [
    CipoListboxComponent,
    CipoNumberComponent,
    CipoSelectComponent,
    CipoTextComponent,
    CipoCheckboxComponent,
    CipoAttachmentComponent,
    CipoDateTimeComponent,
    CipoAddressComponent,
    CipoRadioGroupComponent,
  ],
  exports: [
    CipoListboxComponent,
    CipoNumberComponent,
    CipoSelectComponent,
    CipoTextComponent,
    CipoCheckboxComponent,
    CipoAttachmentComponent,
    CipoDateTimeComponent,
    CipoAddressComponent,
    CipoRadioGroupComponent,
  ],
})
export class CipoFieldsModule {}
